import { SensorTypeEnum } from '@/types/sensor/sensors';

import { Step } from '../../SensorEditingContext';
import { commonDetectionStep, commonGeneralStep, commonLocalizationStep, commonMonitoringStep } from '../common';
import { HolodroneConnectivityForm } from './HolodroneForms';

export const holodroneSteps: Step<SensorTypeEnum.HOLODRONE>[] = [
  commonGeneralStep,
  commonLocalizationStep,
  {
    label: 'connectivity',
    component: HolodroneConnectivityForm,
    validationFields: ['host', 'port', 'grpcPort', 'timeoutThreshold', 'apiKey'],
  },
  commonDetectionStep,
  commonMonitoringStep,
];
